<template>
  <div class="insurance-page">
    <!-- 投保表单主内容区 -->
    <main class="insurance-main">
      <div class="container">
        <div class="page-title">
          <h1>供方人员意外险投保</h1>
          <p>请填写以下信息完成投保申请，带 <span class="required">*</span> 为必填项</p>
        </div>

        <el-form :disabled="isSubmitting" ref="insuranceForm" :model="insuranceForm" :rules="rules" label-width="150px"
                 class="insurance-form">
          <!-- 投保基本信息 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-info-circle"></i> 投保基本信息</h2>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="投保天数" prop="insuranceMonths">
                  <el-radio-group v-model="insuranceForm.insuranceMonths" @change="handleDaysChange">
                    <el-radio label="1">1个月</el-radio>
                    <el-radio label="3">3个月</el-radio>
                    <el-radio label="6">6个月</el-radio>
                    <el-radio label="12">1年</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="24" :md="12">
                <el-form-item label="起保日期" prop="beginTime">
                  <el-date-picker
                    v-model="insuranceForm.beginTime"
                    type="date"
                    @change="handleDaysChange"
                    placeholder="选择起保日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="终保日期" prop="endDate">
                  <el-date-picker
                    v-model="insuranceForm.endDate"
                    type="date"
                    placeholder="终保日期"
                    disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!--保额设置-->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-shield"></i> 保额设置</h2>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="意外身故保额" prop="deathCoverage">
                  <el-input disabled v-model="insuranceForm.deathCoverage" placeholder="请输入意外身故保额"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" :md="12">
                <el-form-item label="意外伤残保额" prop="disabilityCoverage">
                  <el-input disabled v-model="insuranceForm.disabilityCoverage"
                            placeholder="请输入意外伤残保额"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="意外医疗保额" prop="medicalCoverage">
                  <el-input disabled v-model="insuranceForm.medicalCoverage"
                            placeholder="请输入意外医疗保额"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- <el-row :gutter="20">
              <el-col :span="24" :md="24">
                <el-form-item label="附加意外住院津贴" style="text-align: left;">
                  <span style="display: block; text-align: left;">{{ "每人每天 100 元，单次事故最长给付 90 天，累计最长给付180 天。" }}</span>
                </el-form-item>
              </el-col>
            </el-row> -->

            <el-row :gutter="20">
              <el-col :span="24" :md="24">
                <el-form-item label="附加意外住院津贴" style="text-align: left;">
                  <span style="display: block; text-align: left;">{{ "每人每天100元，单次事故最长赔偿90天，累计最长赔偿180天，每次免赔天数3天。" }}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="24">
                <el-form-item label="意外医疗赔偿标准" style="text-align: left;">
                  <span style="display: block; text-align: left;">{{ "意外医疗费用每次事故绝对免赔额为人民币100元。扣除免赔额后，对社保范围内合理医疗费用按90%的比例在保单限额内赔付，非社保范围内医疗费用不予赔偿。" }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 投保人信息 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-user-circle"></i> 投保人信息</h2>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="企业（投保人）名称" prop="appliRealName">
                  <el-input v-model="insuranceForm.appliRealName" placeholder="请输入企业名称,与营业执照中名称一致"></el-input>
                  <div class="form-tip"></div>
                </el-form-item>
              </el-col>

              <el-col :span="24" :md="12">
                <el-form-item label="证件类型" prop="appliIdType">
                  <el-select disabled v-model="insuranceForm.appliIdType" placeholder="请输入企业名称">
                    <el-option label="统一信用代码" value="统一信用代码"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="证件号码" prop="appliIdCard">
                  <el-input
                    v-model="insuranceForm.appliIdCard"
                    placeholder="请输入有效证件号"
                    @blur="validateIdCard"
                  ></el-input>
                  <div v-if="idCardValidationMessage" class="validation-message">{{ idCardValidationMessage }}</div>
                </el-form-item>
              </el-col>

            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="24">
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="insuranceForm.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <!--              <el-col :span="24" :md="12">-->
              <!--                <el-form-item label="联系人" prop="contactPerson">-->
              <!--                  <el-input v-model="insuranceForm.contactPerson" placeholder="请输入联系人姓名"></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->

              <el-col :span="24" :md="12">
                <el-form-item label="联系人手机号" prop="appliContactPhone">
                  <el-input v-model="insuranceForm.appliContactPhone" placeholder="请输入联系人手机号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" :md="12">
                <el-form-item label="电子邮箱" prop="appliEmail">
                  <el-input v-model="insuranceForm.appliEmail" placeholder="请输入电子邮箱,填写后收取电子保单"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 发票模块 -->
                    <div class="form-section">
                      <h2 class="section-title"><i class="fa fa-user-circle"></i> 发票信息</h2>
                      <el-form-item label="发票类型" prop="invoiceType">
                        <el-radio-group v-model="invoiceType">
                          <el-radio-button label="0">不需要发票</el-radio-button>
                          <el-radio-button label="2">增值税普通发票</el-radio-button>
                          <el-radio-button label="1">增值税专用发票</el-radio-button>
                        </el-radio-group>
                      </el-form-item>

                      <!-- 普通发票和专用发票共有的字段 -->
                      <div v-if="invoiceType == 1 || invoiceType == 2">
                        <el-form-item label="公司名称" prop="taxpayerName">
                          <el-input v-model="insuranceForm.taxpayerName" placeholder="请输入公司名称"
                                    maxlength="100"></el-input>
                        </el-form-item>

                        <el-form-item label="纳税人识别号" prop="taxpayerId">
                          <el-input v-model="insuranceForm.taxpayerId" placeholder="请输入纳税人识别号"
                                    maxlength="20"></el-input>
                        </el-form-item>

                        <el-form-item label="邮箱地址" prop="taxEmail">
                          <el-input v-model="insuranceForm.taxEmail" placeholder="请输入邮箱地址"
                                    maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="mobile">
                          <el-input v-model="insuranceForm.mobile" placeholder="请输入联系电话"
                                    maxlength="11"></el-input>
                        </el-form-item>
                      </div>

                      <!-- 专用发票特有字段 -->
                      <div v-if="invoiceType == 1">
                        <el-form-item label="税务登记电话" prop="taxRegisterTel">
                          <el-input v-model="insuranceForm.taxRegisterTel" placeholder="请输入税务登记电话"
                                    maxlength="11"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行" prop="depositeBankName">
                          <el-input v-model="insuranceForm.depositeBankName" placeholder="请输入开户银行"
                                    maxlength="100"></el-input>
                        </el-form-item>

                        <el-form-item label="银行账号" prop="accountNo">
                          <el-input v-model="insuranceForm.accountNo" placeholder="请输入银行账号"
                                    maxlength="50"></el-input>
                        </el-form-item>

                        <el-form-item label="税务登记地址" prop="taxRegisterAddress">
                          <el-input v-model="insuranceForm.taxRegisterAddress" placeholder="请输入税务登记地址"
                                    maxlength="200"></el-input>
                        </el-form-item>
                      </div>
                    </div>

          <!-- 人员清单上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-users"></i> 人员清单</h2>
            <el-form-item label="人员清单上传" prop="excelFile" :error="excelFileError">
              <div style="clear: both; text-align: left; margin-bottom: 10px;">

                <el-button
                  type="default"
                  @click="downloadConfirmationTemplate('人员清单.xls')"
                  icon="el-icon-download"
                  size="medium"
                >
                  下载模板
                </el-button>
              </div>
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-change="handleExcelFileChange"
                :file-list="excelFileList"
                :on-remove="handleExcelFileRemove"
                :limit="1"
                accept=".xlsx,.xls"
                :on-exceed="handleExcelFileExceed">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">
                  请上传包含参保人员信息的Excel，支持的字段：投保人员姓名、性别、身份证号码、年龄、工种
                  <br>系统将自动验证清单字段格式
                </div>
              </el-upload>

              <!--              <div v-if="fileValidationErrors.length > 0" style="margin-top: 10px;">-->
              <!--                <el-alert-->
              <!--                  title="清单验证错误"-->
              <!--                  type="error"-->
              <!--                  :closable="false">-->
              <!--                  <ul>-->
              <!--                    <li v-for="(error, index) in fileValidationErrors" :key="index">{{ error }}</li>-->
              <!--                  </ul>-->
              <!--                </el-alert>-->
              <!--              </div>-->
            </el-form-item>
          </div>

          <!-- 投保确认书上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-file-text"></i> 投保确认书上传</h2>

            <el-form-item label="投保确认书" prop="wordFile" :error="wordFileError">

<!--               调整按钮位置，使其显示在标签下一行并保持左对齐 -->
                            <div style="clear: both; text-align: left; margin-bottom: 10px;">
<!--                              <el-button-->
<!--                                type="default"-->
<!--                                @click="downloadConfirmationTemplate('投保确认书模板示例.docx')"-->
<!--                                icon="el-icon-download"-->
<!--                                size="medium"-->
<!--                              >-->
<!--                                下载模板示例-->
<!--                              </el-button>-->
                              <el-button
                                type="default"
                                @click="downloadConfirmationTemplate('安得智联物流园区意外险投保确认书（供方人员意外险）.docx')"
                                icon="el-icon-download"
                                size="medium"
                              >
                                下载模板
                              </el-button>
                            </div>

              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-remove="handleWordFileRemove"
                :limit="1"
                :file-list="wordFileList"
                :on-change="handleWordFileChange"
                :on-exceed="handleWordFileExceed">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">请上传盖章版《投保确认书》（文件大小不超过7MB）</div>
              </el-upload>
            </el-form-item>
          </div>

          <!-- 营业执照上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-file-text"></i> 营业执照上传</h2>

            <el-form-item label="营业执照" prop="wordFileSecond" :error="wordFileSecondError">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-remove="handleWordFileSecondRemove"
                :limit="1"
                :file-list="wordFileSecondList"
                :on-change="handleWordFileSecondChange"
                :on-exceed="handleWordFileSecondExceed">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">请上传《营业执照》（文件大小不超过7MB）</div>
              </el-upload>
            </el-form-item>
          </div>

          <!-- 其他投保材料上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-file-text"></i> 其他投保材料上传</h2>

            <el-form-item label="其他投保材料" prop="wordFileThird" :error="wordFileThirdError">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-remove="handleWordFileThirdRemove"
                :limit="1"
                :file-list="wordFileThirdList"
                :on-change="handleWordFileThirdChange"
                :on-exceed="handleWordFileThirdExceed">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">请上传其他投保材料（文件大小不超过7MB）</div>
              </el-upload>
            </el-form-item>
          </div>

          <!-- 添加一个按钮来切换内嵌页面的显示 -->
          <!--          <el-button-->
          <!--            type="primary"-->
          <!--            @click="showExternalPage = !showExternalPage"-->
          <!--            style="margin: 20px 0;">-->
          <!--            {{ showExternalPage ? '隐藏内嵌页面' : '显示内嵌页面' }}-->
          <!--          </el-button>-->
          <!-- 提交按钮 -->
          <div class="form-actions">
            <el-button
              type="primary"
              @click="submitForm"
              :disabled="showExternalPage">
              <i v-if="isSubmitting" class="fa fa-spinner fa-spin"></i>
              提交投保单
            </el-button>
            <el-button
              @click="resetForm"
              :disabled="isSubmitting"
            >
              重置
            </el-button>
          </div>

        </el-form>
      </div>
    </main>
  </div>
</template>

<script>
import {service, resultEICurlHead} from '../../utils/axios'
import {getToken} from '../../utils/auth'
import ExternalIframe from '../anDeEIC/Externallframe.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'andeCreateInsEIC',
  components: {
    ExternalIframe
  },
  data () {
    return {
      // 导航相关状态
      isMobile: false,
      showExternalPage: false,
      resultEICurl: '',
      externalUrl: resultEICurlHead + 'resultEIC?id=', // 内嵌页面的URL
      showMobileMenu: false,
      showLoginModal: false,
      showBackToTop: false,
      isSubmitting: false,
      invoiceType: 0,

      // 表单验证消息
      idCardValidationMessage: '',
      // 投保表单数据
      insuranceForm: {

        deathCoverage: '100万', // 意外身故保额（万）
        disabilityCoverage: '100万', // 意外伤残保额（万）
        medicalCoverage: '20万', // 意外医疗保额（万）
        insuranceMonths: '12',
        appliIdType: '统一信用代码',
        beginTime: '', // 起保日期
        endDate: '', // 终保日期
        appliRealName: '', // 企业名称
        address: '',
        appliIdCard: '', // 证件号码
        idType: 'unifiedCreditCode', // 证件类型，默认统一社会信用代码
        appliContactPhone: '', // 联系人手机号
        appliEmail: '', // 电子邮箱
        insuranceConfirmation: null, // 投保确认书
        excelFile: null, // 人员清单
        wordFile: null, // 营业执照
        wordFileSecond: null, // 其他投保材料
        wordFileThird: null, // 其他投保材料
        taxEmail: '',
        taxRegisterTel: '', // 税务登记电话
        mobile: '',
        // 专用发票额外信息
        depositeBankName: '', // 开户银行
        companyName: '', // 企业名称
        taxPayerNo: '',
        taxRegisterAddress: '',
        accountNo: '', // 银行账号
        taxpayerName: '', // 纳税人名称
        taxpayerId: '' // 纳税人识别号
      },
      excelFileList: [], // 用于上传组件显示已选文件
      wordFileList: [], // 用于上传组件显示已选文件
      wordFileSecondList: [], // 用于上传组件显示已选文件
      wordFileThirdList: [], // 用于上传组件显示已选文件
      // 关键：添加文件上传错误信息变量
      excelFileError: '',
      wordFileError: '', // 营业执照
      wordFileSecondError: '', // 其他投保材料
      wordFileThirdError: '', // 其他投保材料
      // 文件验证错误信息
      fileValidationErrors: [],
      pickerOptions: {
        disabledDate: (date) => {
          // 获取今天的日期并设置时间为23:59:59:999
          const today = new Date()
          today.setHours(23, 59, 59, 999)
          // 如果选择的日期小于等于今天，则禁用
          return date <= today
        }
      },

      // 表单验证规则
      rules: {
        beginTime: [
          {required: true, message: '请选择起保日期', trigger: 'change'}
        ],
        // deathCoverage: [
        //   {required: true, message: '请输入意外身故保额', trigger: 'blur'}
        // ],
        // disabilityCoverage: [
        //   {required: true, message: '请输入意外伤残保额', trigger: 'blur'}
        // ],
        // medicalCoverage: [
        //   {required: true, message: '请输入意外医疗保额', trigger: 'blur'}
        // ],
        appliRealName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入地址', trigger: 'blur'}
        ],
        appliIdCard: [
          {required: true, message: '请输入证件号码', trigger: 'blur'}
        ],
        contactPerson: [
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
        appliContactPhone: [
          {required: true, message: '请输入联系人手机号', trigger: 'blur'}
          // ,{pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur'}
        ],
        appliEmail: [
          {type: 'email', message: '请输入有效的电子邮箱', trigger: 'blur'}
        ],
        // 文件上传验证（关键修复）
        excelFile: [
          {required: true, message: '请上传人员清单文件', trigger: ['change', 'blur']}
        ],
        wordFile: [
          {required: true, message: '请上传投保确认书', trigger: ['change', 'blur']}
        ],
        wordFileSecond: [
          {required: true, message: '请上传营业执照', trigger: ['change', 'blur']}
        ],
        taxpayerName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        taxpayerId: [
          {required: true, message: '请输入纳税人识别号', trigger: 'blur'}
        ],
        taxEmail: [
          {required: true, message: '请输入发票邮寄地址', trigger: 'blur'}
        ],
        taxRegisterTel: [
          {required: true, message: '请输入税务登记电话', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        depositeBankName: [
          {required: true, message: '请输入开户银行', trigger: 'blur'}
        ],
        accountNo: [
          {required: true, message: '请输入银行账号', trigger: 'blur'}
        ],
        taxRegisterAddress: [
          {required: true, message: '请输入税务登记地址', trigger: 'blur'}
        ]
      },
      selectedOptions: [] // 选中的地区选项数组，例如 ['zhejiang', 'hangzhou', 'xihu']
    }
  },
  computed: {
    // 判断是否为产品页（导航栏选中状态）
    isProductPage () {
      return false // 投保页不是产品页，所以为false
    }
  },

  created () {
    // 从localStorage加载表单数据
    this.loadFormDataFromCache()
  },
  // 监听表单数据变化，保存到localStorage
  watch: {
    'insuranceForm': {
      handler (newVal) {
        // 排除无法序列化的文件对象
        const formDataToSave = { ...newVal }
        delete formDataToSave.excelFile
        delete formDataToSave.wordFile
        delete formDataToSave.wordFileSecond
        delete formDataToSave.wordFileThird

        localStorage.setItem('insuranceFormCache', JSON.stringify({
          formData: formDataToSave,
          excelFileList: this.excelFileList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          wordFileList: this.wordFileList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          wordFileSecondList: this.wordFileSecondList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          wordFileThirdList: this.wordFileThirdList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          invoiceType: this.invoiceType
        }))
      },
      deep: true
    }
  },
  methods: {
    // 从localStorage加载表单数据
    loadFormDataFromCache () {
      try {
        const cachedData = localStorage.getItem('insuranceFormCache')
        if (cachedData) {
          const parsedData = JSON.parse(cachedData)
          if (parsedData.formData) {
            this.insuranceForm = { ...this.insuranceForm, ...parsedData.formData }
            this.invoiceType = parsedData.invoiceType || 0
            this.excelFileList = parsedData.excelFileList || []
            this.wordFileList = parsedData.wordFileList || []
            this.wordFileSecondList = parsedData.wordFileSecondList || []
            this.wordFileThirdList = parsedData.wordFileThirdList || []
            // 计算终保日期
            // this.calculateEndDate()
          }
        }
      } catch (error) {
        console.error('加载缓存数据失败:', error)
      }
    },
    // 清除表单缓存
    clearFormCache () {
      localStorage.removeItem('insuranceFormCache')
    },
    downloadConfirmationTemplate (fileName) {
      try {
        // 创建一个临时的a标签用于下载
        const link = document.createElement('a')
        // 设置下载文件的路径
        link.href = '/static/' + fileName
        link.download = fileName // 设置下载文件名
        // 触发点击事件开始下载
        document.body.appendChild(link)
        link.click()
        // 下载完成后移除a标签
        setTimeout(() => {
          document.body.removeChild(link)
        }, 100)
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('文件下载失败，请检查文件是否存在')
      }
    },
    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },

    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },

    // 返回顶部
    scrollToTop () {
      window.scrollTo({top: 0, behavior: 'smooth'})
    },

    // 处理投保天数变化
    handleDaysChange (value) {
      if (value === '3') {
        this.$alert('保期为3个月的保单替换率不得大于50%，例如保单期初投保20人，最高替换人次为10人', '提示', {
          confirmButtonText: '确定',
          type: 'info'
        })
      } else if (value === '6') {
        this.$alert('保期为6个月的保单替换率不得大于70%，例如保单期初投保20人，最高替换人次为14人', '提示', {
          confirmButtonText: '确定',
          type: 'info'
        })
      } else if (value === '1') {
        this.$alert('保期为1个月的保单不支持替换', '提示', {
          confirmButtonText: '确定',
          type: 'info'
        })
      }
      // 重新计算终保日期
      this.calculateEndDate()
    },

    // 计算终保日期
    calculateEndDate () {
      if (this.insuranceForm.beginTime) {
        const start = new Date(this.insuranceForm.beginTime)
        const months = parseInt(this.insuranceForm.insuranceMonths)
        // 计算终保日期（起保日期 + 投保月数 - 1天，因为起保日当天也算一天）
        const end = new Date(start)
        // 使用setMonth按月份计算，注意月份是从0开始计数的
        // 为了避免日期溢出问题（比如从1月31日加1个月应该到2月的最后一天），我们先设置到下个月的第一天再减1天
        end.setMonth(start.getMonth() + months)
        end.setDate(end.getDate() - 1)
        this.insuranceForm.endDate = end
      }
    },
    // 关键：手动验证文件字段
    validateFileField (field) {
      this.$refs.insuranceForm.validateField(field, (errorMessage) => {
        if (errorMessage) {
          this[`${field}Error`] = errorMessage
        } else {
          this[`${field}Error`] = ''
        }
      })
    },

    // 提交表单
    submitForm () {
      // 验证证件号码
      this.validateIdCard()
      if (this.idCardValidationMessage) {
        this.$message.error(this.idCardValidationMessage)
        return
      }
      // 关键：先手动验证文件字段
      this.validateFileField('excelFile')
      this.validateFileField('wordFile')
      this.validateFileField('wordFileSecond')
      this.validateFileField('wordFileThird')

      this.$refs.insuranceForm.validate((valid) => {
        if (valid) {
          this.$confirm('确定要提交投保单吗？', '确认提交', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 实际项目中这里会发送请求到后端
            setTimeout(async () => {
              try {
                // 创建FormData对象处理multipart/form-data类型数据
                const formData = new FormData()

                this.isSubmitting = true
                // 添加请求参数（普通字段）
                formData.append('productId', '1948587609948278786')
                formData.append('channelId', '1752141505145974785')
                formData.append('insuranceMonths', this.insuranceForm.insuranceMonths)
                formData.append('beginTime', this.insuranceForm.beginTime)
                formData.append('appliIdCard', this.insuranceForm.appliIdCard)
                formData.append('address', this.insuranceForm.address)
                formData.append('appliEmail', this.insuranceForm.appliEmail)
                formData.append('appliRealName', this.insuranceForm.appliRealName)
                formData.append('appliContactPhone', this.insuranceForm.appliContactPhone)

                formData.append('invoiceType', this.invoiceType)
                formData.append('taxRegisterTel', this.insuranceForm.taxRegisterTel)
                formData.append('mobile', this.insuranceForm.mobile)
                formData.append('depositeBankName', this.insuranceForm.depositeBankName)
                formData.append('accountNo', this.insuranceForm.accountNo)
                formData.append('taxpayerName', this.insuranceForm.taxpayerName)
                formData.append('taxpayerId', this.insuranceForm.taxpayerId)
                formData.append('taxRegisterAddress', this.insuranceForm.taxRegisterAddress)
                formData.append('taxEmail', this.insuranceForm.taxEmail)

                // 添加文件（如果是文件对象需要这样处理）
                if (this.insuranceForm.excelFile) {
                  formData.append('excelFile', this.insuranceForm.excelFile)
                }
                if (this.insuranceForm.wordFile) {
                  formData.append('wordFile', this.insuranceForm.wordFile)
                }
                if (this.insuranceForm.wordFileSecond) {
                  formData.append('wordFileSecond', this.insuranceForm.wordFileSecond)
                }
                if (this.insuranceForm.wordFileThird) {
                  formData.append('wordFileThird', this.insuranceForm.wordFileThird)
                }

                // 发送POST请求
                const res = await service.post(
                  '/andeEIC/eicAccidentInsurance/andeCreateInsEICOne',
                  formData, // 请求体数据（FormData格式）
                  {
                    headers: {
                      'x-access-token': getToken()
                    },
                    timeout: 100000 // 超时设置
                  }
                )

                // 处理响应（注意axios响应数据在res.data中）
                if (res.success) {
                  // 成功逻辑
                  this.$message.success('投保申请提交成功')
                  this.resultEICurl = res.result
                  // 清除表单缓存
                  this.clearFormCache()
                  // 直接使用window.location.href跳转，不再使用内嵌页面
                  // window.location.href = this.externalUrl + this.resultEICurl

                  this.$router.push({
                    path: '/SidebarMenu/anDeEICOrderList',
                    query: { saleId: this.$route.query.saleId }
                  }).then(() => {
                  }).catch(err => {
                    console.error('路由跳转失败:', err)
                  })
                  this.resetForm()
                } else {
                  // 失败逻辑
                  this.$message.error(`提交失败: ${res.message || '未知错误'}`)
                }
              } catch (error) {
                if (error.response && error.response.status === 401) {
                  this.$message.error('登录过期，请重新登录')
                  this.$router.push({path: '/login'})
                }
                // 捕获请求异常（网络错误、超时等）
                console.error('请求发生错误:', error.message)
                this.$message.error(error.message)
              } finally {
                this.isSubmitting = false
              }
            }, 500)
          })
        } else {
          this.$message.error('表单填写存在错误，请检查')
          return false
        }
      })
    },

    // 重置表单
    resetForm () {
      // 先调用element-ui的resetFields方法重置表单
      this.$refs.insuranceForm.resetFields()

      // 清除额外的验证信息和错误
      this.fileValidationErrors = []
      this.idCardValidationMessage = ''
      this.excelFileError = ''
      this.wordFileError = ''
      this.wordFileSecondError = ''
      this.wordFileThirdError = ''

      // 重置文件相关字段
      this.excelFileList = []
      this.wordFileList = []
      this.wordFileSecondList = []
      this.wordFileThirdList = []
      this.insuranceForm.excelFile = null
      this.insuranceForm.wordFile = null
      this.insuranceForm.wordFileSecond = null
      this.insuranceForm.wordFileThird = null
      this.insuranceForm.insuranceConfirmation = null

      // 恢复默认值，确保与初始定义的数据类型一致
      this.insuranceForm.deathCoverage = '100万'
      this.insuranceForm.disabilityCoverage = '100万'
      this.insuranceForm.medicalCoverage = '20万'
      this.insuranceForm.insuranceMonths = '12'
      this.insuranceForm.appliIdType = '统一信用代码'
      this.insuranceForm.idType = 'unifiedCreditCode'

      // 清除其他字段
      this.insuranceForm.beginTime = ''
      this.insuranceForm.endDate = ''
      this.insuranceForm.appliIdCard = ''
      this.insuranceForm.address = ''
      this.insuranceForm.appliEmail = ''
      this.insuranceForm.appliRealName = ''
      this.insuranceForm.appliContactPhone = ''
      this.insuranceForm.taxEmail = ''
      this.insuranceForm.taxRegisterTel = ''
      this.insuranceForm.mobile = ''
      this.insuranceForm.depositeBankName = ''
      this.insuranceForm.companyName = ''
      this.insuranceForm.taxPayerNo = ''
      this.insuranceForm.taxRegisterAddress = ''
      this.insuranceForm.accountNo = ''
      this.insuranceForm.taxpayerName = ''
      this.insuranceForm.taxpayerId = ''

      // 清除缓存
      this.clearFormCache()
    },
    // 处理文件超过数量限制
    handleExcelFileExceed (fileList) {
      try {
        const latestFile = fileList[0]
        this.excelFileList = [latestFile]
        this.excelFileError = ''
        this.fileValidationErrors = []

        // 读取 Excel 文件
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet)

          // 验证表头
          const headerRow = XLSX.utils.sheet_to_json(worksheet, {header: 1})[0]
          const expectedHeaders = ['投保人员姓名', '性别', '身份证号码', '年龄', '工种']
          const isHeaderValid = headerRow.every((header, index) => header === expectedHeaders[index])

          if (!isHeaderValid) {
            this.excelFileError = 'Excel 表头格式不正确，请确保表头为：投保人员姓名\t性别\t身份证号码\t年龄\t工种'
            return
          }

          // 验证数据行数
          if (jsonData.length < 3) {
            this.excelFileError = 'Excel 数据至少需要 3 行'
          }
        }
        reader.readAsArrayBuffer(latestFile)
        this.insuranceForm.excelFile = latestFile
        this.validateFileField('excelFile')
      } catch (error) {
        console.error('文件读取错误:', error)
        this.excelFileError = '文件读取失败，请检查文件格式是否正确'
      }
    },
    // 处理文件超过数量限制
    handleWordFileExceed (fileList) {
      this.$message.warning(`每次只能上传一个文件，已自动替换为新文件`)
      const latestFile = fileList[0]
      this.insuranceForm.wordFile = latestFile
      this.wordFileList = [latestFile]
      this.wordFileError = '' // 清除错误
    },
    handleWordFileSecondExceed (fileList) {
      this.$message.warning(`每次只能上传一个文件，已自动替换为新文件`)
      const latestFile = fileList[0]
      this.insuranceForm.wordFileSecond = latestFile
      this.wordFileSecondList = [latestFile]
      this.wordFileSecondError = '' // 清除错误
    },
    handleWordFileThirdExceed (fileList) {
      this.$message.warning(`每次只能上传一个文件，已自动替换为新文件`)
      const latestFile = fileList[0]
      this.insuranceForm.wordFileThird = latestFile
      this.wordFileThirdList = [latestFile]
      this.wordFileThirdError = '' // 清除错误
    },

    handleExcelFileChange (file) {
      try {
        this.insuranceForm.excelFile = file.raw
        this.excelFileList = [file]
        this.excelFileError = ''
        this.fileValidationErrors = []

        // 读取 Excel 文件
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet)

          // 验证表头
          const headerRow = XLSX.utils.sheet_to_json(worksheet, {header: 1})[0]
          const expectedHeaders = ['投保人员姓名', '性别', '身份证号码', '年龄', '工种']
          const isHeaderValid = headerRow.every((header, index) => header === expectedHeaders[index])

          if (!isHeaderValid) {
            this.excelFileError = 'Excel 表头格式不正确，请确保表头为：投保人员姓名\t性别\t身份证号码\t年龄\t工种'
            return
          }

          // 验证数据行数
          if (jsonData.length < 3) {
            this.excelFileError = 'Excel 数据至少需要 3 行'
          }
        }
        reader.readAsArrayBuffer(file.raw)
      } catch (error) {
        console.error('文件读取错误:', error)
        this.excelFileError = '文件读取失败，请检查文件格式是否正确'
      }
    },

    // 人员清单删除
    handleExcelFileRemove () {
      this.insuranceForm.excelFile = null
      this.excelFileList = [] // 清空列表
      // 关键：文件移除时手动设置错误
      this.excelFileError = '请上传人员清单文件'
    },
    handleWordFileChange (file) {
    // 检查文件大小
      if (this.checkFileSize(file)) {
        this.insuranceForm.wordFile = file.raw
        this.wordFileList = [file] // 强制只显示一个文件
        // 关键：文件变化时手动验证并清除错误
        this.wordFileError = ''
        this.validateFileField('wordFile')
      } else {
        this.wordFileError = '文件大小不能超过5MB'
        this.wordFileList = [] // 清空文件列表
        this.insuranceForm.wordFile = null
      }
    },
    handleWordFileSecondChange (file) {
      if (this.checkFileSize(file)) {
        this.insuranceForm.wordFileSecond = file.raw
        this.wordFileSecondList = [file] // 强制只显示一个文件
        // 关键：文件变化时手动验证并清除错误
        this.wordFileSecondError = ''
        this.validateFileField('wordFileSecond')
      } else {
        this.wordFileSecondError = '文件大小不能超过5MB'
        this.wordFileSecondList = [] // 清空文件列表
        this.insuranceForm.wordFileSecond = null
      }
    },
    handleWordFileThirdChange (file) {
      if (this.checkFileSize(file)) {
        this.insuranceForm.wordFileThird = file.raw
        this.wordFileThirdList = [file] // 强制只显示一个文件
        // 关键：文件变化时手动验证并清除错误
        this.wordFileThirdError = ''
        this.validateFileField('wordFileThird')
      } else {
        this.wordFileThirdError = '文件大小不能超过5MB'
        this.wordFileThirdList = [] // 清空文件列表
        this.insuranceForm.wordFileThird = null
      }
    },
    // 检查文件大小是否超过5MB
    checkFileSize (file) {
      const maxSize = 7 * 1024 * 1024 // 7MB = 7 * 1024 * 1024 字节
      return file.size <= maxSize
    },
    // 验证证件号码
    validateIdCard () {
      const id = this.insuranceForm.appliIdCard
      const type = this.insuranceForm.idType

      if (!id) {
        this.idCardValidationMessage = ''
        return
      }

      // 根据证件类型使用不同的验证规则
      if (type === 'unifiedCreditCode') {
        // 统一社会信用代码验证规则
        const creditCodeReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
        if (!creditCodeReg.test(id)) {
          this.idCardValidationMessage = '请输入有效的统一社会信用代码'
        } else {
          this.idCardValidationMessage = ''
        }
      } else if (type === 'organizationCode') {
        // 组织机构代码验证规则
        const orgCodeReg = /^[0-9A-Z]{8}-[0-9A-Z]$/
        if (!orgCodeReg.test(id)) {
          this.idCardValidationMessage = '请输入有效的组织机构代码'
        } else {
          this.idCardValidationMessage = ''
        }
      } else if (type === 'businessLicense') {
        // 营业执照号码验证规则（较简单，实际应用中可能需要更复杂的验证）
        if (id.length < 15) {
          this.idCardValidationMessage = '请输入有效的营业执照号码'
        } else {
          this.idCardValidationMessage = ''
        }
      }
    },

    // 投保确认书删除
    handleWordFileRemove () {
      this.insuranceForm.wordFile = null
      this.wordFileList = [] // 清空列表
      // 关键：文件移除时手动设置错误
      this.wordFileError = '请上传投保确认书'
    },
    // 投保确认书删除
    handleWordFileSecondRemove () {
      this.insuranceForm.wordFileSecond = null
      this.wordFileSecondList = [] // 清空列表
      // 关键：文件移除时手动设置错误
      this.wordFileSecondError = '请上传营业执照'
    },
    // 投保确认书删除
    handleWordFileThirdRemove () {
      this.insuranceForm.wordFileThird = null
      this.wordFileThirdList = [] // 清空列表
      // 关键：文件移除时手动设置错误
      this.wordFileThirdError = '请上传其他投保材料'
    },
    // 关闭内嵌页面
    closeExternalPage () {
      this.showExternalPage = false
    }
  }
}
</script>
<style scoped>
/* 页面基础样式 */
.insurance-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #333;
  background-color: #f5f7fa;
}

/* 导航栏样式 */
.navbar {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 70px;
  max-width: 1200px;
  margin: 0 auto;
}

.brand {
  font-size: 18px;
  font-weight: bold;
  color: #1890ff;
}

.desktop-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.desktop-menu li {
  margin-left: 30px;
}

.desktop-menu a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.desktop-menu a:hover,
.desktop-menu .active a {
  color: #1890ff;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.mobile-menu {
  position: absolute;
  top: 70px;
  left: 0;
  right: 0;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 15px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.mobile-menu li {
  margin: 0;
  padding: 0 20px;
}

.mobile-menu a {
  display: block;
  color: #666;
  text-decoration: none;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
}

.mobile-menu li:last-child a {
  border-bottom: none;
}

/* 主内容区样式 */
.insurance-main {
  flex: 1;
  margin-top: 90px;
  margin-bottom: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  margin-bottom: 40px;
  text-align: center;
}

.page-title h1 {
  color: #2c3e50;
  font-size: 28px;
  margin-bottom: 10px;
  position: relative;
  display: inline-block;
  padding-bottom: 10px;
}

.page-title h1::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #1890ff;
}

.page-title p {
  color: #666;
  font-size: 14px;
}

.required {
  color: #f56c6c;
}

/* 表单样式 */
.insurance-form {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.form-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 20px;
  padding-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  border-left: 3px solid #1890ff;
}

.section-title i {
  margin-right: 8px;
}

.form-tip, .upload-tip {
  color: #606266;
  font-size: 12px;
  margin-top: 5px;
  line-height: 1.5;
}

.form-actions {
  text-align: center;
  margin-top: 20px;
}

.form-actions .el-button {
  margin: 0 10px;
}

/* 页脚样式 */
.footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 40px 0 20px;
  font-size: 14px;
}

.footer .container {
  text-align: center;
}

.footer p {
  margin-bottom: 20px;
  opacity: 0.8;
}

.footer-links {
  margin-bottom: 30px;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
  margin: 0 10px;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.footer-links a:hover {
  opacity: 1;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #1890ff;
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  font-size: 16px;
  transition: background-color 0.3s;
}

.back-to-top:hover {
  background-color: #096dd9;
}

.validation-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .page-title h1 {
    font-size: 24px;
  }

  .insurance-form {
    padding: 20px 15px;
  }

  .section-title {
    font-size: 15px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/andeCreateInsEIC.vue